// Copia para a área de transferência e avisa por toast. Em http ou sem
// permissão o clipboard rejeita (ou nem existe): vira toast de erro, nunca
// promessa rejeitada solta. Devolve se copiou; `avisarSucesso: false` é para
// quem confirma no próprio controle (o erro continua no toast).
export const copiarTexto = async ({
  texto,
  rotulo,
  addToast,
  avisarSucesso = true,
}) => {
  const erro = () =>
    addToast({
      type: "error",
      align: "top",
      title: "Erro ao copiar",
      description: "Não foi possível copiar. Selecione o texto e copie.",
    });

  if (!texto) {
    erro();
    return false;
  }
  try {
    await navigator.clipboard.writeText(texto);
  } catch {
    erro();
    return false;
  }
  if (!avisarSucesso) return true;
  addToast({
    type: "success",
    align: "top",
    title: "Copiado com sucesso",
    description: `${rotulo || "Copiado"} com sucesso`,
  });
  return true;
};
